import React from 'react';

import { Heading } from '../style';
import { LinkButton } from './style';

const InformationRequestConfirmation = (): JSX.Element => (
  <React.Fragment>
    <Heading>Look out for an email from our support team</Heading>
    <p>
      They’ll let you know once they’ve completed your request—or ask for any
      additional information if needed.
    </p>
    <LinkButton buttonType="secondary" href="/" data-test-id="home">
      Return home
    </LinkButton>
  </React.Fragment>
);

export default InformationRequestConfirmation;
